import { render, staticRenderFns } from "./pending-students.vue?vue&type=template&id=f0350abe&scoped=true&"
import script from "./pending-students.vue?vue&type=script&lang=js&"
export * from "./pending-students.vue?vue&type=script&lang=js&"
import style0 from "./pending-students.vue?vue&type=style&index=0&id=f0350abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0350abe",
  null
  
)

component.options.__file = "pending-students.vue"
export default component.exports